/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GroupUptimeValue
 */
export interface GroupUptimeValue {
    /**
     * Uptime percentage (0-1) with offline periods included
     * @type {number}
     * @memberof GroupUptimeValue
     */
    uptimeOfflineIncluded?: number;
    /**
     * Uptime percentage (0-1) with offline periods excluded
     * @type {number}
     * @memberof GroupUptimeValue
     */
    uptimeOfflineExcluded?: number;
    /**
     * The preferred uptime value based on org preference
     * @type {number}
     * @memberof GroupUptimeValue
     */
    preferredUptime?: number;
    /**
     * Which calculation method was used for PreferredUptime
     * @type {boolean}
     * @memberof GroupUptimeValue
     */
    isOfflineIncluded?: boolean;
}

/**
 * Check if a given object implements the GroupUptimeValue interface.
 */
export function instanceOfGroupUptimeValue(
    value: object,
): value is GroupUptimeValue {
    return true;
}

export function GroupUptimeValueFromJSON(json: any): GroupUptimeValue {
    return GroupUptimeValueFromJSONTyped(json, false);
}

export function GroupUptimeValueFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GroupUptimeValue {
    if (json == null) {
        return json;
    }
    return {
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
    };
}

export function GroupUptimeValueToJSON(value?: GroupUptimeValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
    };
}
